import ApiService from '../../services/ApiService.js';

export const namespaced = true;

export const state = {};

export const mutations = {
};

export const actions = {
	// eslint-disable-next-line
	getShotMetaData() {
		return ApiService.getShotMetaData();
	},

	addShot({commit}, data) {
		return ApiService.addShot(data);
	},
};

export const getters = {};
